import { AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import { useOnQueryError } from "@/hooks";
import { HydraErrorResponse } from "@/types";
import { SettingsService } from "../services";
import { SettingsSuccessResponse } from "../types";

const useSettingsList = () => {
  const onError = useOnQueryError("settings.list.default_error");
  return useQuery<SettingsSuccessResponse, AxiosError<HydraErrorResponse>>({
    queryKey: ["settings-list"],
    queryFn: () => SettingsService.get(),
    meta: {
      onError,
    },
  });
};

export { useSettingsList };
